module.exports = __webpack_public_path__ + "aa429c2c807a696b76f5b16e3eb55bf7.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room2/audio1/02_1MCA-Sip-My-Ocean.ogg
// module id = 769
// module chunks = 0